/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enddate1Inputs */

const de__field_enddate1 = /** @type {(inputs: _Field_Enddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum`)
};

/**

* @param {_Field_Enddate1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_enddate1 = /** @type {((inputs?: _Field_Enddate1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enddate1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_enddate1(inputs)
});
export { _field_enddate1 as "_field_endDate" }